import { PropType } from 'vue';
import plantsClient from '@/core/services/plants';
import { Options, Vue } from 'vue-class-component';
import {
  EntrancePlantDetailDTO,
  SwitchboardDTO,
} from '@/../client-generator/generated-clients/plants';
import SwitchboardItem from './SwitchboardItem/SwitchboardItem.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import DialogAddEditSwitchboard from './DialogAddEditSwitchboard/DialogAddEditSwitchboard.vue';

@Options({
  name: 'EntrancePlantSwitchboards',
  props: {
    currentPlant: {
      type: Object as PropType<EntrancePlantDetailDTO>,
      required: true,
    },
  },
  components: {
    SwitchboardItem,
    DialogAddEditSwitchboard,
  },
  emits: ['update-list'],
})
export default class EntrancePlantSwitchboards extends Vue {
  currentPlant!: EntrancePlantDetailDTO;
  switchboardToEdit: SwitchboardDTO | null = null;
  isVisibleAddEditSwitchboard = false;
  isVisibleDeleteSwitchboardConfirm = false;

  async mounted() {
    if (this.$route.query.addSwitchboard) {
      this.handleAddSwitchboard();
    }
  }

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  get switchboards() {
    return this.currentPlant.switchboards;
  }

  get hasSwitchboards() {
    if (this.switchboards) {
      return this.switchboards.length > 0;
    }
    return false;
  }

  async handleDeleteSwitchboard(switchboard: SwitchboardDTO) {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await plantsClient.switchboardDELETE(
        this.currentPlant.desktopId as number,
        switchboard
      );

      this.$emit('update-list');
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: this.$t('AppResourceEP.SwitchboardBannerDeleted'),
          closable: false,
          life: 3000,
        });
      }, 1500);
    } catch {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleAddSwitchboard() {
    this.switchboardToEdit = null;
    this.isVisibleAddEditSwitchboard = !this.isVisibleAddEditSwitchboard;
  }

  handleEditSwitchboard(switchboard: SwitchboardDTO) {
    this.switchboardToEdit = switchboard;
    this.isVisibleAddEditSwitchboard = !this.isVisibleAddEditSwitchboard;
  }

  hideAddEditSwitchboard() {
    this.isVisibleAddEditSwitchboard = !this.isVisibleAddEditSwitchboard;
  }

  handleUpdateList() {
    this.$emit('update-list');
  }
}
